import type { FC } from 'react';

import type { BreakPatternProps } from './breakPatternTypes';

export const StraightBreak: FC<BreakPatternProps> = props => {
  const { topColor, bottomColor, shadowColor, shadowOpacity = 0.2, ...rest } = props;
  return (
    <svg
      width="1440"
      height="96"
      viewBox="0 0 1440 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      role="presentation"
      {...rest}
    >
      <defs>
        <filter id="break-straight-shadow" x="0" y="0" width="100%" height="96">
          <feGaussianBlur stdDeviation="15" />
          <feComposite operator="out" in2="SourceGraphic" />
        </filter>
      </defs>

      {/* Top section */}
      <rect x="0" y="0" width="100%" height="48" fill={topColor} />

      {/* Bottom section */}
      <rect
        x="0"
        y="0"
        width="100%"
        height="48"
        fill={bottomColor}
        transform="translate(0 48)" // Move to bottom of the SVG container
      />

      {/* Drop shadow (same path as the top section with the filter applied) */}
      <rect
        x="0"
        y="0"
        width="100%"
        height="48"
        fill={shadowColor}
        opacity={shadowOpacity}
        filter="url(#break-straight-shadow)"
      />
    </svg>
  );
};
